/* Arabmusk UX additions (2026-09-26). Loaded with defer after global.js. */

(function () {
  'use strict';

  /* ---------- Free shipping progress bar ---------- */
  if (!customElements.get('free-shipping-bar')) {
    class FreeShippingBar extends HTMLElement {
      connectedCallback() {
        this.threshold = parseInt(this.dataset.threshold, 10) || 10000;
        this.text = this.querySelector('.free-shipping-bar__text');
        this.track = this.querySelector('.free-shipping-bar__track');
        this.fill = this.querySelector('.free-shipping-bar__fill');

        // Dawn publishes cartUpdate after every add (product form, quick add) and every
        // quantity change on the cart page.
        if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          this.unsubscribe = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.refresh());
        }
      }

      disconnectedCallback() {
        if (this.unsubscribe) this.unsubscribe();
      }

      formatMoney(cents) {
        const locale = this.dataset.locale || document.documentElement.lang || 'nl';
        const decimal = locale === 'en' ? '.' : ',';
        return '€' + (cents / 100).toFixed(2).replace('.', decimal);
      }

      refresh() {
        const cartUrl = (window.routes && window.routes.cart_url) || '/cart';
        fetch(`${cartUrl}.js`, { headers: { Accept: 'application/json' } })
          .then((response) => response.json())
          .then((cart) => this.render(cart))
          .catch(() => {});
      }

      render(cart) {
        const total = cart.total_price || 0;
        const remaining = this.threshold - total;
        const percent = Math.max(0, Math.min(100, Math.floor((total / this.threshold) * 100)));
        const message =
          remaining > 0
            ? (this.dataset.msgRemaining || '').replace('[amount]', this.formatMoney(remaining))
            : this.dataset.msgDone || '';

        this.hidden = !cart.item_count;
        this.classList.toggle('free-shipping-bar--done', remaining <= 0);
        if (this.text) this.text.textContent = message;
        if (this.fill) this.fill.style.width = `${percent}%`;
        if (this.track) {
          this.track.setAttribute('aria-valuenow', percent);
          this.track.setAttribute('aria-label', message);
        }
      }
    }
    customElements.define('free-shipping-bar', FreeShippingBar);
  }

  /* ---------- Collection description: "read more" ---------- */
  function initReadMore(root) {
    root.querySelectorAll('[data-am-collapsible]').forEach((description) => {
      const button = document.querySelector(`[aria-controls="${description.id}"]`);
      if (!button || button.dataset.amBound) return;
      button.dataset.amBound = 'true';

      const overflowing = description.scrollHeight - description.clientHeight > 2;
      button.hidden = !overflowing;

      button.addEventListener('click', () => {
        const expanded = description.classList.toggle('is-expanded');
        button.setAttribute('aria-expanded', expanded);
        button.textContent = expanded ? button.dataset.less : button.dataset.more;
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initReadMore(document));
  } else {
    initReadMore(document);
  }
  document.addEventListener('shopify:section:load', (event) => initReadMore(event.target));
})();
